import React from 'react';
import { Inbox } from '../Inbox';
import { InboxConfigProvider } from './index';

export default (): React.ReactElement => {
    return (
        <InboxConfigProvider
            loginEmail='user@example.com'
            baseUrl='/proxy/to/notify'
            onTokenRequest={() => Promise.reject(new Error('not implemented'))}
        >
            <Inbox />
        </InboxConfigProvider>
    );
};


export const src = "import React from 'react';\nimport { Inbox } from '../Inbox';\nimport { InboxConfigProvider } from './index';\n\nexport default (): React.ReactElement => {\n    return (\n        <InboxConfigProvider\n            loginEmail='user@example.com'\n            baseUrl='/proxy/to/notify'\n            onTokenRequest={() => Promise.reject(new Error('not implemented'))}\n        >\n            <Inbox />\n        </InboxConfigProvider>\n    );\n};\n";